import { render, staticRenderFns } from "./SuggestedCreatorsItem.vue?vue&type=template&id=6d9b8622&scoped=true&"
import script from "./SuggestedCreatorsItem.vue?vue&type=script&lang=ts&"
export * from "./SuggestedCreatorsItem.vue?vue&type=script&lang=ts&"
import style0 from "./SuggestedCreatorsItem.vue?vue&type=style&index=0&id=6d9b8622&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d9b8622",
  null
  
)

export default component.exports